import { Pipe, PipeTransform } from '@angular/core';
import { GuestTitle } from '../constants/commonenums';

@Pipe({
    name: 'guestTitle',
    standalone: false
})
export class GuestTitlePipe implements PipeTransform {

  transform(title: any): any {
    return (title > 0) ? GuestTitle[title] : "";
  }

}
